import axios from 'axios';
import Cookies from 'js-cookie';
import config from '../../config';

const baseUrl = config.baseUrl;
const poaEndpoint = '/api/poassostenibilidad';

const getPoaEndpointSoportes = '/api/poassostenibilidadsoportes';
const postPoaEndpointSoportes = '/api/poassostenibilidadupload';
const poaEndpointDelete = '/api/poassostenibilidaddelete';
const poaEndpointUpdateValue = '/api/update-poa-value';
const sd_sostenibilidadEndpoint = '/api/sd_sostenibilidad';



// ✅ Crear una instancia de Axios
const api = axios.create({
    baseURL: baseUrl,
});

// ✅ Interceptor para agregar el token a cada solicitud
api.interceptors.request.use(
    (config) => {
        const token = Cookies.get('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);


// 🔍 Obtener todos los POAs
export const getAllPoasSostenibilidad = async () => {
    try {
        const response = await axios.get(`${baseUrl}${poaEndpoint}`);
        return response.data;
    } catch (error) {
        console.error("Error al obtener todos los POAs:", error);
        throw error;
    }
};

// 🔍 Obtener un POA por código de proyecto (codProyecto)
export const getPoasSostenibilidad = async (codigoInterno) => {
    try {
        const response = await axios.get(`${baseUrl}${poaEndpoint}/${codigoInterno}`);
        return response.data;
    } catch (error) {
        console.error(`Error al obtener el POA con código ${codigoInterno}:`, error);
        throw error;
    }
};


// 🆕 Crear un nuevo POA
export const createPoasSostenibilidad = async (nuevoPoa) => {
    try {
        const response = await axios.post(`${baseUrl}${poaEndpoint}`, nuevoPoa);
        return response.data;
    } catch (error) {
        console.error("Error al crear el POA:", error);
        throw error;
    }
};

// ✅ Servicio para actualizar POA
export const updatePoasSostenibilidad = async (codigoInterno, poaActualizado) => {
    try {
        const response = await api.put(
            `${poaEndpoint}/${codigoInterno}`,
            poaActualizado, // ✅ Aseguramos que se envíe en el body
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );

        return response.data;
    } catch (error) {
        console.error(`❌ Error al actualizar el POA con código ${codigoInterno}:`, error.response?.data || error);
        throw error;
    }
};

// ❌ Eliminar un POA por código de proyecto
export const deletePoasSostenibilidad = async (codigoInterno) => {
    try {
        const response = await axios.delete(`${baseUrl}${poaEndpoint}/${codigoInterno}`);
        return response.data;
    } catch (error) {
        console.error(`Error al eliminar el POA con código ${codigoInterno}:`, error);
        throw error;
    }
};



//Soportes POA

// 🔍 Obtener los Soportes POA por código de proyecto y actividad
export const getPoasSostenibilidadSoportes = async (codigoInterno, keyActividad) => {
    try {
        const response = await axios.post(`${baseUrl}${getPoaEndpointSoportes}`, {
            codigoInterno,
            keyActividad
        });
        return response.data;
    } catch (error) {
        if (error.response?.status === 404) {
            console.warn(`📢 POA ${codigoInterno} sin soportes cargados para la actividad ${keyActividad}`);
            return []; // ✅ Retorna un array vacío en lugar de lanzar un error
        }

        console.error("❌ Error al obtener los soportes del POA:", error);
        return []; // ✅ En caso de otro error, también retorna un array vacío
    }
};




//Cargar Soportes POA postPoaEndpointSoportes
// 🆕 Cargar Soportes POA con archivos

export const uploadPoasSostenibilidadSoportes = async (codigoInterno, keyActividad, userName, files, dataFile, typeFile) => {
    try {
        const formData = new FormData();

        // ✅ Agregar datos al formulario
        formData.append("codigoInterno", codigoInterno);
        formData.append("keyActividad", keyActividad);
        formData.append("userName", userName);
        formData.append("typeFile", JSON.stringify(typeFile));
        formData.append("dataFile", JSON.stringify(dataFile));

        // ✅ Agregar archivos (verificar contenido)
        files.forEach((file, index) => {

            formData.append("imagenes", file);
        });


        // ✅ Enviar la solicitud
        const response = await axios.post(`${baseUrl}${postPoaEndpointSoportes}`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });

        return response.data;

    } catch (error) {
        console.error("❌ Error al subir archivos del POA:", error.response?.data || error);
        throw error;
    }
};


// ❌ Eliminar un soporte del POA 
export const deletePoaSostenibilidadSoporte = async (rutaImagen, codigoInterno, userName) => {
    try {
        const response = await api.post(poaEndpointDelete, {
            rutaImagen,
            codigoInterno,
            userName
        });

        return response.data;
    } catch (error) {
        console.error(`❌ Error al eliminar el soporte con rutaImagen ${rutaImagen}:`, error.response?.data || error);
        throw error;
    }
};




// ✅ Servicio para actualizar Value POA
export const updatePoasSostenibilidadValue = async (codigoInterno, keyRegistro, newValue) => {
    try {
        const response = await api.put(
            `${poaEndpointUpdateValue}/${codigoInterno}`,
            { keyRegistro, newValue },
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );

        return response.data;
    } catch (error) {
        console.error(`❌ Error al actualizar el POA con código ${codigoInterno}:`, error.response?.data || error);
        throw error;
    }
};



// 🔍 Obtener todos los POAs
export const getAllsd_Sostenibilidad = async () => {
    try {
        const response = await axios.get(`${baseUrl}${sd_sostenibilidadEndpoint}`);
        return response.data;
    } catch (error) {
        console.error("Error al obtener los registros", error);
        throw error;
    }
};